import { getTopText } from "../../functions/announcement";
import { isoToFormatDate } from "../../functions/formatTime";
import Row from "../common/List/Row";

const AnnouncementRow = ({ announcement, showEditPopUp }) => {
  const cellTexts = [
    getTopText(announcement),
    isoToFormatDate(announcement.createdAt, "yyyy/MM/dd HH:mm"),
    announcement.type,
  ];

  const noteTexts = [announcement.title, announcement.text];

  const cellAlign = ["C", "C", "L"];

  return (
    <Row
      cellTexts={cellTexts}
      noteTexts={noteTexts}
      showPopUp={() => showEditPopUp(announcement)}
      cellAlign={cellAlign}
    />
  );
};

export default AnnouncementRow;
